export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5161.3a625046.jpg";